import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Printer, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import ProPortalHeader from '@/components/ProPortalHeader';
import { HelpToc } from '@/components/help/HelpToc';
import { ManualChapter } from '@/components/help/ManualChapter';
import { tileMatches } from '@/components/help/manualTheme';
import { INSTALLER_GUIDE } from '@/data/manual/installerGuide';

export default function InstallerGuide() {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const sections = useMemo(
    () => INSTALLER_GUIDE.map((s) => ({ section: s, tiles: s.tiles.filter((t) => tileMatches(t, query)) })).filter((x) => x.tiles.length),
    [query],
  );
  return (
    <div className="min-h-screen bg-gray-50" data-testid="installer-guide-page">
      <div className="no-print"><ProPortalHeader activeSection="home" /></div>
      <div className="bg-white border-b border-gray-200 no-print sticky top-0 z-20">
        <div className="max-w-5xl mx-auto px-3 sm:px-4 py-3 flex flex-wrap items-center gap-2 sm:gap-3">
          <button type="button" onClick={() => navigate('/')} className="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-[#27292E]" data-testid="guide-back"><ArrowLeft className="w-4 h-4" /> Home</button>
          <h1 className="text-base sm:text-lg font-bold text-[#27292E] mr-auto">How to use the portal</h1>
          <div className="relative w-full sm:w-64 order-last sm:order-none">
            <Search className="w-4 h-4 text-gray-400 absolute left-2.5 top-1/2 -translate-y-1/2" />
            <Input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search the guide…" className="pl-8 h-9" data-testid="guide-search" />
          </div>
          <Button size="sm" onClick={() => window.print()} className="bg-[#2F5E96] hover:bg-[#264d7a] text-white" data-testid="guide-print"><Printer className="w-4 h-4 mr-1.5" /> Print / Save as PDF</Button>
        </div>
      </div>
      <div className="print-only hidden px-2 pb-4 border-b border-gray-300 mb-4">
        <div className="text-3xl font-bold text-[#27292E]">Ox Resin Installer Portal</div>
        <div className="text-lg text-gray-700">Installer & trainee guide</div>
      </div>
      <div className="max-w-5xl mx-auto px-3 sm:px-4 py-5 grid gap-5 lg:grid-cols-[220px_1fr]">
        <div><HelpToc sections={sections.map((x) => ({ ...x.section, count: x.tiles.length }))} /></div>
        <div className="space-y-5 min-w-0">
          {sections.map((x) => <ManualChapter key={x.section.id} section={x.section} tiles={x.tiles} full />)}
          {sections.length === 0 && <div className="text-sm text-gray-500 italic" data-testid="guide-empty">Nothing matches "{query}".</div>}
        </div>
      </div>
    </div>
  );
}
